import React from 'react'
import AwesomeError from 'components/Common/AwesomeError'
import { connect } from 'react-redux'
import BodyText from 'components/Luxkit/Typography/BodyText'

interface Props {
  contactNumber: App.GeoContact;
}

/** @deprecated */
function CalendarRecommendationsNotAvailableMessage(props: Props) {
  const { contactNumber } = props
  return (
    <AwesomeError title="No offers found for the dates you requested.">
      <BodyText variant="large" colour="neutral-one">
        But we probably have something for you.<br />
        <a
          href={`tel:${contactNumber.number}`}
          rel="nofollow"
        >{contactNumber.humanReadable}
        </a>.
      </BodyText>
    </AwesomeError>
  )
}

function mapStateToProps(state: App.State) {
  return {
    contactNumber: state.geo.currentContact.local,
  }
}

export default connect(mapStateToProps)(CalendarRecommendationsNotAvailableMessage)
